const Footer = () => {
  return (
    <footer
      className="relative border-t border-[var(--bone)]/10 py-10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-12 gap-4 items-center">
        <div className="col-span-12 md:col-span-4 font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--bone-dim)]">
          © 2026 · Preeti Basu ·{" "}
          <a
            href="https://preetibasu.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-website"
            className="text-[var(--bone)] hover:text-[var(--copper)] link-line"
          >
            preetibasu.com
          </a>
        </div>
        <div className="col-span-12 md:col-span-4 text-center">
          <span className="font-serif italic text-[var(--bone)]">
            Ship money, gracefully.
          </span>
          <span className="text-[var(--copper)] ml-2">✦</span>
        </div>
        <div className="col-span-12 md:col-span-4 flex md:justify-end gap-6">
          <a
            href="https://www.linkedin.com/in/preeti-basu-671967a3/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--bone-dim)] hover:text-[var(--copper)] link-line"
          >
            LinkedIn
          </a>
          <a
            href="https://x.com/PreetiBasu7"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-twitter"
            className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--bone-dim)] hover:text-[var(--copper)] link-line"
          >
            Twitter
          </a>
          <a
            href="mailto:basupreeti1007@gmail.com"
            data-testid="footer-email"
            className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--bone-dim)] hover:text-[var(--copper)] link-line"
          >
            Email
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
